import { render, staticRenderFns } from "./MdmModel.vue?vue&type=template&id=6f5e664a"
import script from "./MdmModel.vue?vue&type=script&lang=js"
export * from "./MdmModel.vue?vue&type=script&lang=js"
import style0 from "./MdmModel.vue?vue&type=style&index=0&id=6f5e664a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports